import { Box, SxProps, Theme, useTheme } from "@mui/material";
import { CheckIcon } from "components/icons";
import React from "react";

export const CheckRadio = ({
  onClick,
  isDisabled = false,
  isLoading = false,
  status = "unchecked",
  sx,
}: {
  onClick: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  status: "checked" | "unchecked";
  sx?: SxProps<Theme>;
}) => {
  const theme = useTheme();
  return (
    <Box
      component="button"
      onClick={() => !isDisabled && !isLoading && onClick()}
      sx={{
        mt: "2px",
        width: "20px",
        height: "20px",
        aspectRatio: "1",
        borderRadius: "100%",
        display: "flex",
        justifyContent: "center",
        cursor: isLoading ? "progress" : "pointer",
        alignItems: "center",
        border: `1.5px solid ${
          status === "checked"
            ? theme.palette.success.main
            : theme.palette.neutral["020"]
        }`,
        backgroundColor: `${
          status === "checked" ? theme.palette.success.main : "#FFF"
        }`,
        ...sx,
        // cursor: "pointer",
      }}
    >
      <CheckIcon
        htmlColor="#fff"
        fontSize="small"
        sx={{ width: "12px", height: "12px" }}
      />
    </Box>
  );
};
